import FilteredCaseStudies from "./FilteredCaseStudies";

export default FilteredCaseStudies;